import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import { Spacings, Fonts } from '../../../../styleConstants';
import { sectionsIds } from '../sections';
import Sections from './Sections';
import RegisterButton from '../RegisterButton';

const SectionsWrapper = styled.div`
  float: right;
  display: grid;
  grid-template: 1fr / repeat(
      ${({ $showButton }) => ($showButton ? 4 : 3)},
      max-content
    );
  grid-column-gap: ${Spacings.SPACING_10B};
  align-items: center;
`;

const StyledButton = styled(RegisterButton)`
  padding: ${Spacings.SPACING_3B} ${Spacings.SPACING_6B};
  font-size: ${Fonts.H5};
  line-height: ${Fonts.HEADER_LINE_HEIGHT};
  margin-top: ${Spacings.SPACING_0B};
`;

const HeaderSections = ({ headerRefs, showRegisterButton }) => {
  return (
    <SectionsWrapper $showButton={showRegisterButton}>
      <Sections headerRefs={headerRefs} />
      {showRegisterButton && (
        <StyledButton scheduleRef={headerRefs[sectionsIds.schedule]} />
      )}
    </SectionsWrapper>
  );
};

HeaderSections.propTypes = {
  headerRefs: PropTypes.objectOf(PropTypes.object).isRequired,
  showRegisterButton: PropTypes.bool
};

HeaderSections.defaultProps = {
  showRegisterButton: false
};

export default HeaderSections;
